import * as orderTracking from './orderTracking';
import * as orderLimits from './orderLimits';

export const Actions = {
  ...orderTracking,
  ...orderLimits,
};
